module.exports = __webpack_public_path__ + "img/icon-project.62f63da9.svg";